export default __webpack_public_path__ + "static/Segoe UI Bold-b00928e669b80413600433124705f9a2.ttf";